__turbopack_context__.v({
  "hasBorder": "Ghlpha_hasBorder",
  "image": "Ghlpha_image",
  "name": "Ghlpha_name",
});
